import React from "react";
import { useTranslation } from "react-i18next";
import { SwitchButton } from "../../../../common/components/switch-button/SwitchButton";
import { useTheme } from "../../../../theme/useTheme";
import styles from "./appearance-page.module.scss";
import { DarkThemeIcon, LightThemeIcon } from "../../../../assets/icons";
import { CustomCheckBox, CheckboxShape } from "../../../../common/components/checkbox/CustomCheckBox";
import LanguageSelector from "../../../../common/components/language-selector/LanguageSelector";
import CustomerPageLayout from "../../customer-page-layout/CustomerPageLayout";

export const AppearancePage: React.FC = () => {
	const { t } = useTranslation();
	const { preference, setPreference } = useTheme();
	const useDeviceSettings = preference === "system";

	const selectLight = () => {
		if (useDeviceSettings) return;
		setPreference("light");
	};
	const selectDark = () => {
		if (useDeviceSettings) return;
		setPreference("dark");
	};
	const toggleDeviceSettings = (next: boolean) => {
		setPreference(next ? "system" : "light");
	};

	const lightSelected = !useDeviceSettings && preference === "light";
	const darkSelected = !useDeviceSettings && preference === "dark";

	return (
		<CustomerPageLayout title={t("account.appearance")} subtitle={t("account.web.appearanceSubtitle")} showBackButton={true} decreaseMainContentPadding>
			<div className={styles.languageRow}>
				<span className={styles.languageTitle}>{t("account.choosePreferredLanguage")}</span>
				<LanguageSelector />
			</div>

			<div className={styles.card}>
				<div className={`${styles.thumbnailRow} ${useDeviceSettings ? styles.thumbnailRowDisabled : ""}`}>
					<button
						type="button"
						className={`${styles.thumbnailCol} ${lightSelected ? styles.thumbnailColActive : ""}`}
						onClick={selectLight}
						disabled={useDeviceSettings}
						aria-pressed={lightSelected}
					>
						<LightThemeIcon />
						<span className={styles.thumbnailLabelRow}>
							<CustomCheckBox isChecked={lightSelected} checkboxShape={CheckboxShape.circle} />
							<span className={styles.thumbnailLabel}>{t("account.light")}</span>
						</span>
					</button>
					<span className={styles.thumbnailDivider} aria-hidden />
					<button type="button" className={`${styles.thumbnailCol}`} onClick={selectDark} disabled={useDeviceSettings} aria-pressed={darkSelected}>
						<DarkThemeIcon />
						<span className={styles.thumbnailLabelRow}>
							<CustomCheckBox isChecked={darkSelected} checkboxShape={CheckboxShape.circle} />
							<span className={styles.thumbnailLabel}>{t("account.dark")}</span>
						</span>
					</button>
				</div>

				<hr className={styles.divider} />

				<div className={styles.deviceRow}>
					<div className={styles.deviceMain}>
						<span className={styles.deviceTitle}>{t("account.useDeviceSettings")}</span>
						<span className={styles.deviceBody}>{t("account.useDeviceSettingsDescription")}</span>
					</div>
					<SwitchButton isActive={useDeviceSettings} onChange={toggleDeviceSettings} size="md" activeColor="var(--app-primary)" />
				</div>
			</div>
		</CustomerPageLayout>
	);
};

export default AppearancePage;
